// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"44a9bb28","67":"63a7665f","201":"0ab664f7","286":"209392e9","392":"591239e1","444":"67cf2f47","526":"cf72d433","543":"16960a94","681":"0853bb6f","696":"cd6c99a6","714":"63fde72a","769":"d00bb683","992":"ee040cb4"}[chunkId] + ".chunk.js";
};